// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AssetTradingMode;
(function (AssetTradingMode) {
    AssetTradingMode[AssetTradingMode["Delivery"] = 0] = "Delivery";
    AssetTradingMode[AssetTradingMode["General"] = 1] = "General";
    AssetTradingMode[AssetTradingMode["All"] = 2] = "All";
})(AssetTradingMode || (AssetTradingMode = {}));
export var CalculationMethod;
(function (CalculationMethod) {
    CalculationMethod[CalculationMethod["Last"] = 0] = "Last";
    CalculationMethod[CalculationMethod["PrevClose"] = 1] = "PrevClose";
})(CalculationMethod || (CalculationMethod = {}));
